/* index.js */

"use strict";
const Steve = require("@gluenetworks/steve_core").getInstance(),
    ServiceAddon = require("@gluenetworks/login_center").ServiceAddon,
    SteveRouter = require("@gluenetworks/steve_core_router");

const newSteveRouter = new SteveRouter(window, window.history, Steve.log);

// const user = require("../../../../../user"); //uncomment to get credentials

/****************************************************/
/* START STEVE ADD-ONS */
/****************************************************/

new ServiceAddon(Steve.log, Steve.di, newSteveRouter).startUp(Steve).then((resultServices) => {
    Steve.di.registry.register("$teve.services", resultServices);

    // All the things!!!
    const CannedSpaghetti = require("@gluenetworks/control_app_navigation").steveAddons
        .CannedSpaghetti;
    Steve.addOn("CannedSpaghetti", CannedSpaghetti, {
        addOnMode: true,
        registrationFqn: "$teve.privates.cannedSpaghetti",
    });

    // JNIB Adapter Add On
    const JnibAdapter = require("@gluenetworks/jnib_adapter_addon").steveAddons.control;
    Steve.addOn("JnibAdapter", JnibAdapter, {addOnMode: true});

    /****************************************************/
    /* END STEVE ADD-ONS                                */
    /* LAUNCH APP                                       */
    /****************************************************/
    /* Uncomment the below code to auto login
    if (user.userName) {
        Steve.di.registry.register("$eededBits.credentials", {
            username: user.userName,
            password: user.pass,
        });
    }
    */

    Steve.launchApp({
        defaultRoute: {
            app: "GameConsole",
            s: "LoginCenter",
        },
    });
});
